/* noted. — Skipstone club config. THE ONE PLACE THESE NUMBERS LIVE.

   Pulled out of skipstone-portal.js on 2026-08-21 because these figures moved
   several times in one evening and each move meant rewriting a 10KB file.
   Config, not code. Change them here and nothing else needs touching. */

/* ---------------------------------------------------------------
   1. TIER MINIMUMS

   Keyed by the bundle's ProductVariant id, which appears in the subscription
   row class and on .bundle-container as pv_<id>.

   SPEND IS THE ONLY MINIMUM. Confirmed by Justin 2026-08-21, from Patricia.
   A member may take any number of items so long as the net total clears the
   figure below. `bottles: 0` is how that is expressed: the guard still checks
   the count, it simply can never fail. The field is left in place rather than
   removed because the rule may come back, and a zero is a one-character
   change. Removing it would mean editing the guard again.

   These supersede the 675 / 1770 / 3660 that was in awtomic-theme-custom.js.
   Those were never policy: they were each tier's default box total, and that
   block was deleted from that file in v2.3.
--------------------------------------------------------------- */
window.SKIPSTONE_TIERS = {
  "54150225953132": { name: "Cave Collector", bottles: 0, spend: 550 },
  "54150226248044": { name: "Wine Vault",     bottles: 0, spend: 1500 },
  "54150226444652": { name: "Cellar Master",  bottles: 0, spend: 3000 }
};

/* ---------------------------------------------------------------
   2. MEMBER PRICING — DISPLAY ONLY. READ THIS BEFORE CHANGING A NUMBER.

   THIS TABLE DOES NOT CHARGE ANYONE. It renders the struck retail price and
   the member price on the allocation rows in the portal. The money a member is
   actually billed comes from Awtomic: Tools > Memberships > [tier] >
   Benefits > Product discounts, which drives a Shopify automatic discount
   called "Memberships Discount Checkout".

   Verified 2026-08-21 by reading every active variant in Shopify:
   compareAtPrice is null on all of them. Nothing here comes from Shopify's
   compare-at field, and the struck prices on the builder cards are Awtomic's,
   not ours.

   SO EVERY CHANGE HERE HAS A TWIN IN AWTOMIC, ON ALL THREE TIERS. Change one
   without the other and the portal shows a member one price while Awtomic
   charges another. There is no guard against that drift. It is a two-system
   edit every time.

   THE RETAIL COLUMN IS SHOPIFY'S VARIANT PRICE. Keep it that way. If a wine's
   Shopify price changes, this retail figure changes with it.

   MATCH ON THE FULL TITLE INCLUDING THE SIZE. Matching is a substring test on
   the row's product name, so a bare "2024 Oliver's Blend" also catches the
   1.5L and would price a $500 magnum at $225. That was live until 2026-08-21.
   Same trap on "2023 Faultline", which has a 1.5L at $500.

   A WINE ABSENT FROM THIS TABLE RENDERS AT RETAIL WITH NO STRIKE, which is how
   "no preferred pricing" is expressed. It is also the safe failure for a wine
   nobody remembered to add: it under-promises rather than showing a member a
   discount they will not get.

   SOURCE: Justin, 2026-08-21.
     2024 Oliver's Blend 750ml            250 -> 225
     2024 Malbec 750ml                    150 -> 140
     2024 Preface 750ml                    85 ->  75
     2023 Oliver's Blend Cab Sauv 750ml   225 -> 200
     2023 Faultline Vineyard 750ml        225 -> 200
     2023 Ripple Effect Cab Sauv 750ml    175 -> 165

   The 2023 reds carry the same discount as their 2024 counterparts, so a
   member pays the same for either vintage.

   DELIBERATELY ABSENT, no preferred pricing, all confirmed by Justin:
     2024 Oliver's Blend 1.5L      $500 flat
     2022 Preface Proprietary Red   $85 flat
     2007 Rose de Constance         $200 flat
     every large format of every wine

   NOT YET CONFIRMED, so deliberately left out rather than guessed:
     2023 Malbec 750ml   would be 150 -> 140 to match the 2024
     2023 Preface 750ml  would be  85 ->  75 to match the 2024
   Add them here the same day they are added in Awtomic, not before.

   UPDATE THIS EVERY RELEASE.
--------------------------------------------------------------- */
window.SKIPSTONE_PRICES = [
  { match: "2024 Oliver's Blend - 750ml",                    retail: 250, member: 225 },
  { match: "2024 Malbec - 750ml",                            retail: 150, member: 140 },
  { match: "2024 Preface - 750ml",                           retail: 85,  member: 75 },
  { match: "2023 Oliver's Blend Cabernet Sauvignon - 750ml", retail: 225, member: 200 },
  { match: "2023 Faultline Vineyard - 750ml",                retail: 225, member: 200 },
  { match: "2023 Ripple Effect Cabernet Sauvignon - 750ml",  retail: 175, member: 165 }
];

/* ---------------------------------------------------------------
   3. BUNDLE ORDER

   The order the lines in an allocation are read on the membership page.
   Awtomic prints them in whatever order its own data happens to hold, which
   put the olive oil between the two wines. Justin, 2026-08-21: Oliver's,
   Malbec, olive oil, in that order.

   TWO LISTS, NOT ONE, ON PURPOSE. Naming every wine would mean editing this
   every release and would silently mis-sort anything left out. Instead:

     FIRST  — these lead, in the order written here.
     LAST   — these trail, in the order written here.
     Everything else keeps the order Awtomic gave it, in the middle.

   Matched case-insensitively on the line's product name. Keep the fragments
   short enough to survive a vintage change and specific enough not to collide.
--------------------------------------------------------------- */
window.SKIPSTONE_BUNDLE_ORDER = {
  first: ["oliver's blend", "malbec"],
  last:  ["olive oil"]
};
